<template>
  <div class="calendar-modal modal-container">
    <div class="modal-wrapper">
      <div
        class="row m-0 h-75"
        style="padding-top: 50px;">
        <div class="col-sm-5 d-flex justify-content-center">
          <div class="elements">
            <div class="image">
              <img :src="getImageURL(abr)">
            </div>
            <div class="image-name text-center">
              <h3 v-if="name">{{ name }}</h3>
              <p v-else>No title</p>
            </div>
          </div>
          <hr>
        </div>
        <div class="col-sm-7 d-block justify-content-center">
          <div class="week-counter d-flex justify-content-between">
            <div
              class="minus-button"
              @click="elementsCount -= 1">
              <MinusSvg/>
            </div>
            <div class="counter d-flex align-items-center">
              <div>
                <h3 class="m-0">{{ elementsCount }}</h3>
              </div>
            </div>
            <div
              class="plus-button"
              @click="elementsCount += 1">
              <PlusSvg />
            </div>
          </div>
          <div class="justify-content-center d-flex text-center mt-3">
            <span style="font-size: 10px;">X For week</span>
          </div>
          <div class="week-days d-flex justify-content-center align-items-center mt-1">
            <div class="select-day">
              <CheckboxWeek
                :date="days"
                @days="setDay"/>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <span style="font-size: 10px;">Select frequency and days per week</span>
          </div>
          <div class="select-product mt-3">
            <div>
              <multiselect
                v-model="selected"
                :options="option"
                :option-height="104"
                :custom-label="customLabel"
                :show-labels="false"
                label="title"
                track-by="title">
                <template
                  slot="singleLabel"
                  slot-scope="props"><img
                    :src="props.option.image"
                    class="option__image"
                    style="height: 50px;">
                  <span class="option__desc">
                    <span
                      v-if="props.option.name"
                      class="option__title ml-2">
                      {{ props.option.name }}
                    </span>
                    <span
                      v-else
                      class="option__title ml-2">
                      No title
                    </span>
                  </span>
                </template>
                <template
                  slot="option"
                  slot-scope="props"><img
                    :src="props.option.image"
                    class="option__image"
                    style="height: 50px;">
                  <div class="option__desc d-inline-block">
                    <span
                      v-if="props.option.name"
                      class="option__title d-inline-block">
                      {{ props.option.name }}
                    </span>
                    <span
                      v-else
                      class="option__title d-inline-block">
                      No title
                    </span>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="row m-0">
        <div class="col d-flex justify-content-center">
          <div class="save-block">
            <span @click="submitData">save</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import profileMixin from "@/mixins/profileMixin";
import PlusSvg from "@/components/SVG/Plus";
import MinusSvg from "@/components/SVG/Minus";
import CheckboxWeek from "../../CheckboxWeek";
import Multiselect from 'vue-multiselect';

import {mapActions, mapGetters} from 'vuex';

export default {
  name: "RegimenCalendarModal",
  components: {PlusSvg, MinusSvg, CheckboxWeek, Multiselect},
  mixins: [profileMixin],

  data() {
    return {
      abr: '',
      name: '',
      elementsCount: 1,
      weekDays: [],
      productId: null,
      elementId: null,
      option: [],
      selected: null,
    }
  },
  computed: {
    ...mapGetters(['days', 'user'])
  },

  created() {

      const modalData = this.$store.state.Auth.modal.data;
      if(modalData) {
        this.prepareData(modalData);
      }
      this.option =  this.$store.state.Squarespace.productsLog[0].products;
  },

  methods: {
    ...mapActions(['saveRegimenCalendar', 'getUserWeek', 'fetchUserRegimenElements']),
    customLabel ({ title, desc }) {
      return `${title} – ${desc}`
    },
    setDay(data) {
        this.weekDays = data;
    },

    prepareData(data) {
      this.abr = data.elements.abr;
      this.name = data.elements.element_name;
    },

    submitData() {
        let data = {
          'element_frequency': this.elementsCount,
          'weekDays': this.weekDays,
          'product': this.selected,
          'element': this.abr
        };

        let params = {
            'userId': this.user.id,
        }
        this.saveRegimenCalendar(data).then(() => {
          this.showModal(false);
          this.getUserWeek();
          this.fetchUserRegimenElements(params)
        });
    },

    getImageURL(imgABR) {
      try {
        return require('@/assets/images/icons/' + imgABR + '.png');
      } catch (e) {
        return require('@/assets/images/no-image.png');
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/RegimenCalendarModal/RegimenCalendarModal.vue